const VALEURS_INUTILES = new Set(["x", "fon", "com", "."]);

// On garde une Map pour les remplacements automatiques des termes génériques
const NOMS_GENERIQUES_MAP = new Map([
  ["le secretariat", "Le Secrétariat"],
  ["secretariat", "Le Secrétariat"],
  ["secrétariat", "Le Secrétariat"],
  ["administration", "L'Administration"], // Bonus : tu peux en ajouter d'autres
  ["direction", "La Direction"],
]);

function isInutile(value: string | null | undefined): boolean {
  if (!value || value.trim() === "") return true;
  return VALEURS_INUTILES.has(value.toLowerCase().trim());
}

function getGeneriqueRemplacement(value: string | null | undefined): string | null {
  if (!value || value.trim() === "") return null;
  const valLower = value.toLowerCase().trim();
  return NOMS_GENERIQUES_MAP.get(valLower) || null;
}

function capitalize(str: string): string {
  return str
    .toLowerCase()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function formatUserGreeting(user: {
  nom?: string | null;
  prenom?: string | null;
  titre?: string | null;
}): string {
  const prenom = user.prenom?.trim();
  const nom = user.nom?.trim();
  const titre = user.titre?.trim();

  const prenomValide = !isInutile(prenom) && prenom;
  const nomValide = !isInutile(nom) && nom;
  const titreValide = !isInutile(titre) && titre;

  // 1. Vérifier si c'est un nom générique (renvoie la valeur formatée si trouvé)
  const nomGenerique = getGeneriqueRemplacement(nom);
  if (nomValide && nomGenerique) {
    return nomGenerique; // Renvoie "Le Secrétariat"
  }

  // 2. Titre valide + Nom → "Mr Dupont"
  if (titreValide && nomValide) return `${capitalize(titre)} ${capitalize(nom)}`;

  // 3. Prénom + Nom → "Jean Dupont"
  if (prenomValide && nomValide) return `${capitalize(prenom)} ${capitalize(nom)}`;

  // 4. Juste Prénom ou juste Nom
  if (nomValide) return capitalize(nom);
  if (prenomValide) return capitalize(prenom);
  

  return "";
}